var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-top-title"},[_c('div',{staticClass:"page-top-title__item"},[_c('h2',{staticClass:"content-title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"page-top-title__item text-right"})])}
var staticRenderFns = []

export { render, staticRenderFns }